export const MY_SHIFTS_PATH = "myShifts";
